import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.closeOnBackdrop = this.closeOnBackdrop.bind(this)
    this.dialogTarget?.addEventListener("click", this.closeOnBackdrop)
  }

  disconnect() {
    this.dialogTarget?.removeEventListener("click", this.closeOnBackdrop)
  }

  open() {
    if (this.dialogTarget.open) return
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
